import React from 'react';

class About extends React.Component {
    componentDidMount() {
        console.log("Initializing Photography.About..");
        // const hideAboutShowlink = function () {
        //     let aboutlink = document.getElementById('about-link');
        //     aboutlink.className = 'dimNavLink';
        // };
        //doing this from NavBar now
        // hideAboutShowlink();

    }


    render() {
        return (
            <div align="center">
                <img src="photography/A29C4734x.jpg" alt="my photograph" className="aboutImage col-1 child about-inline-block-child" />
                <div className="aside col-4 child about-inline-block-child">
                    <h2>CHRIS MAREK</h2>
                    <hr style={{ width: '30%', height: '2px', borderWidth: '0', backgroundColor: 'gray', marginTop: '0em' }} />
                    <br></br>
                    <p className="left-align-text">A native of the Dallas area, as a child, Chris grew up exploring fields and creeks when much of Dallas was yet to be developed. In those early years, Chris's wildlife observation skills became well developed, as did his knowledge of wildlife behavior. The key thing is patience. Patience is easy to have when one is so fascinated with nature that just sitting and watching some natural event unfold is supreme entertainment. That could be a spider wasp chasing down a wolf spider, or a horned lizard on tip toes picking off harvester ants. Needless to say patience and an understanding of his subjects is the key when photographing natural subjects. He enjoys road trips each fall through the American west, and has traveled to Central and South America and South Africa. On his trips to the rainforest in Peru, Chris was amazed at how easy it was for him to find forest creatures while those who accompanied him found mostly nothing. It goes back to those early days in Dallas.</p>
                    <p className="left-align-text">Chris took up photography back in the era of film. Shooting film was an expensive proposition. Each frame was carefully exposed to avoid waste. And understanding how to make perfect exposures was a real skill when shooting film. All that changed when digital finally came along. It is still critically important to make every exposure perfect, but now it is possible to be less frugal with the number of exposures it takes to capture subjects in motion. The challenge of photographing birds in flight is much more plausible and an exciting pursuit. The patience Chris developed all those years ago pays off today when photographing fast moving subjects.</p>
                </div>
            </div>
        )
    }
}

//NOTE action creator included here
export default About;



